import type { Root } from "mdast";
import type { TextDirective } from "mdast-util-directive";
import { visit } from "unist-util-visit";

export const MENTION_ELEMENT_TAG = "tktl-mention";

export const remarkMentionDirective = () => {
  return (tree: Root) => {
    visit(tree, "textDirective", (node: TextDirective) => {
      if (node.name !== "mention") return;
      const { id, icon, variant, ...meta } = node.attributes ?? {};
      if (!id) {
        node.data = { ...node.data, hName: "span" };
        return;
      }
      const baseProperties: Record<string, string> = {
        "data-mention-id": id,
      };
      if (icon) baseProperties["data-mention-icon"] = icon;
      if (variant) baseProperties["data-mention-variant"] = variant;
      const metaProperties = Object.fromEntries(
        Object.entries(meta)
          .filter(([, value]) => value != null)
          .map(([key, value]) => [`data-mention-meta-${key}`, String(value)]),
      );
      node.data = {
        ...node.data,
        hName: MENTION_ELEMENT_TAG,
        hProperties: { ...baseProperties, ...metaProperties },
      };
    });
  };
};
